import { GetContextMenuItemsParams, MenuItemDef } from 'ag-grid-community'
import OpenInPHIconDisable from 'assets/icons/open-in-ph-menu-disable.svg'
import OpenInPHIcon from 'assets/icons/open-in-ph-menu.svg'
import { clearAlertQueue, setAlertQueue } from 'cache/alerts'
import errorMessages from 'constants/errorMessages'
import { MessageType } from 'ts/enums/messageType.enums'

const PRICEHUB_URL = process.env.REACT_APP_PRICEHUB_URL

/**
 * Creates an "Open in Price Hub" menu item for the row context menu.
 * @param params - AG Grid context menu parameters
 * @returns Menu item definition for opening in PriceHub
 */
export const openInPriceHubMenuItem = (params: GetContextMenuItemsParams): MenuItemDef => {
  const dealId = params.node?.data?.dealNr ?? ''
  const icon = dealId ? OpenInPHIcon : OpenInPHIconDisable

  const handleOnAlertClose = () => {
    sessionStorage.clear()
    clearAlertQueue()
  }

  return {
    name: 'Open in Price Hub',
    action: () => {
      if (dealId) {
        setAlertQueue({
          type: MessageType.INFO,
          message: errorMessages.VPN_CONNECTION_WARNING,
          onClose: handleOnAlertClose,
          onOk: () => {
            window.open(`${PRICEHUB_URL}/deal/${dealId}`, '_blank', 'noopener,noreferrer')
          },
        })
      }
    },
    icon: `<img src="${encodeURI(icon)}" alt="Open in PriceHub" role="img" aria-label="Open in PriceHub action icon" onerror="this.style.display='none'" />`,
    disabled: !dealId,
  }
}
